// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"108":"5236d26b3dba5c2ce27d","452":"02c37d9767011eeabeb8"}[chunkId] + ".js";
};